import React from 'react';
import { useTranslation } from 'react-i18next';
import Partners from "../../components/Partners/Partners";

const AboutUs = () => {
    const { t } = useTranslation();

    const glass = {
        background: 'rgba(10, 10, 18, 0.55)',
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: '24px',
    };

    return (
        <>
            {/* Hero */}
            <section style={{ padding: '140px 0 60px', textAlign: 'center', background: 'transparent' }}>
                <div className="container">
                    <h1 style={{ color: '#fff', fontSize: '3.5rem', fontWeight: '800' }}>
                        {t("About")} <span style={{ color: '#45d0bd' }}>WIZ</span>
                    </h1>
                    <p style={{ color: '#6b6b88', maxWidth: '700px', margin: '20px auto 0' }}>
                        {t("We are a technology engineering firm dedicated to building the infrastructures of tomorrow.")}
                    </p>
                </div>
            </section>

            {/* Main about */}
            <section style={{ background: 'transparent', padding: '60px 0' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 mb-4 mb-lg-0">
                            <div className="tilt-card" style={{ ...glass, padding: '36px', borderLeft: '3px solid #45d0bd' }}>
                                <span style={{ fontSize: '3.5rem', fontWeight: '800', color: '#fff', display: 'block' }}>10</span>
                                <span style={{ fontSize: '1.8rem', color: '#45d0bd', fontWeight: '600' }}>k+</span>
                                <p style={{ color: '#8888aa', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '10px', fontSize: '0.85rem' }}>
                                    {t("Intelligent Systems Deployed")}
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <h2 style={{ marginBottom: '25px', color: '#fff' }}>
                                {t("Engineering the Future of Intelligence")}
                            </h2>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#8888aa' }}>
                                {t("WIZ is a technology engineering firm dedicated to building scalable, connected infrastructures. We specialize in bridging the gap between hardware and software, integrating advanced AI with industrial-grade automation. Our mission is to modernize global operations through precise engineering and intelligent system design.")}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission / Vision / Values */}
            <section style={{ background: 'transparent', padding: '60px 0 100px' }}>
                <div className="container">
                    <div className="row">
                        {[
                            { title: t("Our Mission"), text: t("To empower industries with connected systems that enhance efficiency and drive innovation through engineering excellence.") },
                            { title: t("Our Vision"),  text: t("To become the global leader in providing integrated software-hardware ecosystems for the modern world.") },
                            { title: t("Our Values"),  text: t("Precision in engineering, transparency in execution, and a relentless focus on scalable impact.") },
                        ].map((card, i) => (
                            <div className="col-md-4 mb-4" key={i}>
                                <div className="tilt-card" style={{ ...glass, padding: '36px', height: '100%' }}>
                                    <h3 style={{ color: '#45d0bd', marginBottom: '15px' }}>{card.title}</h3>
                                    <p style={{ color: '#8888aa', lineHeight: '1.8' }}>{card.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Partners />
        </>
    );
};

export default AboutUs;
